module.exports = "/fonts/fa-brands-400.eot?92078a27adb3d46ba8089c452cd70bf6";